import { __makeTemplateObject } from "tslib";
import { Avatar as MuiAvatar } from "@material-ui/core";
import styled from "styled-components";
export var Avatar = styled(MuiAvatar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\ttext-decoration: none;\n\tcolor: ", ";\n\tbackground-color: ", ";\n"], ["\n\ttext-decoration: none;\n\tcolor: ", ";\n\tbackground-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.Avatar.textColor;
}, function (_a) {
    var theme = _a.theme, src = _a.src;
    return (!!src ? "transpaernt" : theme.palette.Avatar.bgColor);
});
var templateObject_1;
//# sourceMappingURL=styles.js.map